import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DialogResult, DialogResultType } from "../DialogResult";
import {
  DropDownItem,
  UdInteractFilters,
  US_SubHeader,
} from "../../api/models";
import { ShareState } from "../../elements/share-editor/share-editor.component";

export interface ReportExportDialogData {
  subInteractReportExportId: number;
  userSubscriptions: US_SubHeader[];
  shareState: ShareState;
  isNewExport: boolean;
  name: string;
  description: string;
  subscriptionId: number;
  exportFormat: string;
}

@Component({
  selector: "report-export-filter-dialog",
  templateUrl: "./report-export-dialog.component.html",
})
export class ReportExportDialogComponent {
  public Result: DialogResult;

  constructor(
    public dialogRef: MatDialogRef<ReportExportDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ReportExportDialogData
  ) {
    this.Result = new DialogResult();
    this.Result.ResultType = DialogResultType.Cancel;
    this.Result.ResultData = data;
    this.Result.ResultData.exportFormat = "pdf";
  }

  onCancelClick(): void {
    this.dialogRef.close(this.Result);
  }

  onConfirmClick(): void {
    this.Result.ResultType = DialogResultType.Ok;
    this.dialogRef.close(this.Result);
  }
}
